/* eslint-disable */

import Utils from './utils';


let license = "MIT";

const MANIFEST = {
    "Name": "My Cool Icons",
    "Version": "1.0.0",
    "Description": "A collection of my favourite icons for Stream Deck.",
    "Author": "Jane Doe",
    "URL": "https://example.com",
    "Icon": "",
    "License": "MIT",
};

export class ESDIconPackManifest {
    // #privateField; // doesn't work in FF
    constructor (options = {}) {
        this.__manifestFilePath = '';
        this.__loaded = false;
        this.__license = license;
        this.__iconPack = options.iconPack;
        // this.#privateField = 42;
        Object.assign(this, MANIFEST, options, {License:license});
        this._Icon = "";
    }
    set license(value) {
        // console.log("[ESDIconPackManifest]:license", typeof value, value);
        if(typeof value === 'string') {
            this.__license = value;
        } else {
            Utils.fetchFile(this.getFileObj(value), 'text').then(inData => {
                console.log("ESDIconPackManifest:fetchedLicense:", inData);
                this.__license = inData;
            });
        }
    }

    get license() {
        return this.__license;
    }

    set Icon(value) {
        // icon is set to a string
        const found = this.__iconPack.icons.find(i => i.name == value);
        if(found) {
            // console.log("[ESDIconPackManifest]:found icon in icons:", found && found.file);
            this.__iconPack.icon = found.file;
            this.__iconPack.removeIcon(found);
        }
        this._Icon = value;
    }

    get Icon() {
        return this._Icon;
    }

    toJSON() {
        return this.compile();
    }

    toString() {
        return JSON.stringify(this.compile(), null, 4);
    }

    setFile(f) {

    }

    setLicenseText(value) {
        this.__license = value;
    }

    get loaded() {
        return this.__loaded;
    }

    set manifestjson(value) {
        this.readFromFile(value);
    }

    get manifestjson() {
        return this.__manifestFilePath;
    }

    readFromFile(f) {
        return f && this.readFromFileObject(this.getFileObj(f));
    }

    readFromFileObject(f) {
        return Utils.fetchFile(f, "text").then(inData => {
            let data = Utils.parseJson(inData, (catchedErr) => {}) || {};
            // console.log("Manifest:readFromFileObject", f, data);
            Object.entries(data).map(props => {
                this[props[0]] = props[1];
                // console.log(props[0], props[1]);
                // Utils.fetchXhr;
            });
            // Object.assign(this, data);
            this.__manifestFilePath = f.fullPath || f.name || '';
            return this;
        });
    }

    readFile(f) {
        if(f.name.toLowerCase() === "manifest.json") {
            this.readFromFile(f);
        }
    }

    compile() {
        const o = {};
        Object.keys(MANIFEST).map(k => {
            console.log("ESDIconPackManifest:compile", k, this[k]);
            o[k] = this[k];
        });
        // console.trace(o);
        return o;
        // return Utils.pick(this, Object.keys(MANIFEST));
    }

    getFileObj(f) {
        if(f instanceof File) {
            return f;
        } else if(f.file && f.file instanceof File) {
            return f.file;
        } else if(f.fileObject && f.fileObject instanceof File) {
            return f.fileObject;
        }
    }

}
